module.exports = __webpack_public_path__ + "static/media/joshsurprised.625cda02.png";